var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router';
import useFetch from '../../common/useFetch';
import useLoginTheme from '../../common/useLoginTheme';
import AuthService from '../../domain/AuthService';
import gs from '../../styles/style';
import { UserContext } from '../Auth/UserProvider';
import ErrorResponseHandler from '../Common/ErrorResponseHandler';
import { Errors, Form, Input, SubmitButton, useForm } from '../Common/Form';
import Loader from '../Common/Loader';
import style from './TwoFactorAuthentication.scss';
var FontAwesomeIcon = require('@fortawesome/react-fontawesome').FontAwesomeIcon;
var TwoFactorAuthentication = function () {
    useLoginTheme();
    var t = useTranslation()[0];
    var _a = useContext(UserContext), user = _a.user, twoFactorConfirmed = _a.twoFactorConfirmed, setTwoFactorConfirmed = _a.setTwoFactorConfirmed, logout = _a.logout;
    var _b = useFetch(AuthService.TFASecret), secret = _b.data, getSecret = _b.get;
    useEffect(function () {
        getSecret();
    }, []);
    var loading = secret === undefined;
    var form = useForm({
        onSubmit: AuthService.verify2FA,
        onSuccess: function () { return setTwoFactorConfirmed(true); }
    });
    useEffect(function () {
        form.setValue('secret', (secret === null || secret === void 0 ? void 0 : secret.secret) || null);
    }, [secret]);
    if (!user || twoFactorConfirmed) {
        return React.createElement(Redirect, { to: "/" });
    }
    return React.createElement("div", { className: style['two-factor-authentication-container'] },
        React.createElement(ErrorResponseHandler, null),
        React.createElement("h1", { className: gs('mb-5') }, t('lotus')),
        React.createElement("div", { className: gs('card') },
            React.createElement("div", { className: gs('card-body', style['two-factor-authentication-form']) },
                loading && React.createElement("div", { className: gs('text-center') },
                    React.createElement(Loader, null)),
                !loading && React.createElement(Form, { form: form },
                    React.createElement("h4", { className: gs('mt-2', 'text-center') },
                        React.createElement("span", { className: gs('text-muted') },
                            React.createElement(FontAwesomeIcon, { icon: "lock" })),
                        ' ',
                        t('enter_tfa_code', { name: user.name })),
                    React.createElement("hr", { className: gs('mt-4', 'mb-4') }),
                    secret.qr && React.createElement("div", { className: gs('text-center') },
                        React.createElement("img", { src: secret.qr }),
                        React.createElement("div", null,
                            React.createElement("small", null, t('setup_tfa_instructions')))),
                    React.createElement("fieldset", null,
                        React.createElement("div", { className: gs('form-group') },
                            React.createElement("label", null, t('code')),
                            React.createElement(Input, __assign({}, form.string('code'), { autoFocus: true, className: gs('form-control-lg'), required: true })),
                            React.createElement(Errors, { attribute: "code", errors: form.getErrors('code') })),
                        React.createElement(SubmitButton, { form: form, className: gs('btn-block', 'btn-lg') }, t('continue')),
                        React.createElement("div", { className: gs('mt-4', 'text-center', 'text-small') },
                            React.createElement("a", { onClick: function () { return logout.post(); }, className: gs('text-muted', 'link', { 'disabled': logout.loading }), tabIndex: -1 }, t('go_back'))))))));
};
export default TwoFactorAuthentication;
